import { render, staticRenderFns } from "./LogoEmblem.vue?vue&type=template&id=028600d4"
import script from "./LogoEmblem.vue?vue&type=script&lang=js"
export * from "./LogoEmblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports